// OpenObserve 集成（参照 hippocampus 实现，适配 CRA 环境变量）

export const readOpenObserveConfig = () => {
  const enabled = String(process.env.REACT_APP_OO_ENABLED || '').toLowerCase() === 'true';
  const baseUrl = (process.env.REACT_APP_OO_URL || '').replace(/\/$/, '');
  const organization = process.env.REACT_APP_OO_ORG || '';
  const stream = process.env.REACT_APP_OO_STREAM || 'frontend_logs';
  const authType = String(process.env.REACT_APP_OO_AUTH_TYPE || '').toLowerCase();

  let auth;
  if (authType === 'token') {
    const token = process.env.REACT_APP_OO_TOKEN || '';
    if (token) auth = { type: 'token', token };
  } else if (authType === 'basic') {
    const username = process.env.REACT_APP_OO_USER || '';
    const password = process.env.REACT_APP_OO_PASSWORD || '';
    if (username && password) auth = { type: 'basic', username, password };
  } else if (authType === 'basic_b64') {
    const basicB64 = process.env.REACT_APP_OO_BASIC_B64 || '';
    if (basicB64) auth = { type: 'basic_b64', basicB64 };
  }

  return {
    enabled,
    baseUrl,
    organization,
    stream,
    auth,
    batchSize: Number(process.env.REACT_APP_OO_BATCH_SIZE || 20),
    flushIntervalMs: Number(process.env.REACT_APP_OO_FLUSH_MS || 3000),
  };
};

export class OpenObserveSink {
  constructor(config) {
    this.config = config;
    this.endpoint = `${config.baseUrl}/api/${encodeURIComponent(config.organization)}/${encodeURIComponent(config.stream)}/_json${this.#getTokenQuery(config.auth)}`;
    this.headers = this.#buildHeaders(config.auth);
    this.queue = [];
    this.timer = undefined;
    this.requiresHeaderAuth = !!config.auth && (config.auth.type === 'basic' || config.auth.type === 'basic_b64');
    this.#startTimer();
    try {
      if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', this.#handleUnload);
        window.addEventListener('pagehide', this.#handleUnload);
      }
    } catch { }
  }

  emit(level, args) {
    if (!this.config.enabled) return;
    try {
      const now = new Date().toISOString();
      const text = this.#stringifyArgs(Array.isArray(args) ? args : [args]);
      const append = Array.isArray(args) ? {} : args;
      const record = {
        level,
        message: text,
        ts: now,
        page: typeof window !== 'undefined' && window.location ? window.location.pathname : undefined,
        url: typeof window !== 'undefined' && window.location ? window.location.href : undefined,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
        ...append,
      };
      this.queue.push(record);
      if (this.queue.length >= this.config.batchSize) {
        this.flush();
      }
    } catch { }
  }

  flush = () => { void this.#flushInternal(); };
  flushNow = () => { void this.#flushInternal(); };

  #handleUnload = () => {
    this.flush();
    this.#stopTimer();
  };

  #startTimer() {
    if (this.timer) return;
    this.timer = setInterval(() => {
      this.flush();
    }, this.config.flushIntervalMs);
  }

  #stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }

  async #flushInternal() {
    if (!this.config.enabled) return;
    if (this.queue.length === 0) return;
    const payload = this.queue.splice(0, this.queue.length);
    try {
      const body = JSON.stringify(payload);
      const canUseBeacon = !this.requiresHeaderAuth && typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
      if (canUseBeacon) {
        try {
          const blob = new Blob([body], { type: 'application/json' });
          navigator.sendBeacon(this.endpoint, blob);
          return;
        } catch { }
      }

      await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...this.headers,
        },
        body,
        keepalive: true,
      });
    } catch { }
  }

  #getTokenQuery(auth) {
    if (!auth) return '';
    if (auth.type === 'token') {
      return `?token=${encodeURIComponent(auth.token)}`;
    }
    return '';
  }

  #buildHeaders(auth) {
    if (!auth) return {};
    if (auth.type === 'basic') {
      const basic = btoa(`${auth.username}:${auth.password}`);
      return { Authorization: `Basic ${basic}` };
    }
    if (auth.type === 'basic_b64') {
      const v = auth.basicB64.trim();
      const header = v.toLowerCase().startsWith('basic ') ? v : `Basic ${v}`;
      return { Authorization: header };
    }
    return {};
  }

  #stringifyArgs(args) {
    try {
      return args
        .map((a) => (typeof a === 'string' ? a : JSON.stringify(a)))
        .join(' ')
        .slice(0, 4000);
    } catch {
      return String(args);
    }
  }
}


